import { PropertyStepsEnum } from '@pages/hubs/Property/enum/property-steps-enum';

export const propertyCreateFormStepper = [
  PropertyStepsEnum.preStepPropertyType,
  PropertyStepsEnum.generalBase,
  PropertyStepsEnum.generalSecond,
  PropertyStepsEnum.propertyFeatures,
  PropertyStepsEnum.propertyAmenities,
  PropertyStepsEnum.propertySkillsAmenities,
  PropertyStepsEnum.propertyPhoto,
  PropertyStepsEnum.propertyLandlord,
  PropertyStepsEnum.propertyResidents,
  PropertyStepsEnum.propertyShare,
  PropertyStepsEnum.congratulations,
];

export const propertyFormStepper = {
  [PropertyStepsEnum.preStepPropertyType]: {
    stepId: PropertyStepsEnum.preStepPropertyType,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 0,
  },
  [PropertyStepsEnum.generalBase]: {
    stepId: PropertyStepsEnum.generalBase,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 1,
  },
  [PropertyStepsEnum.generalSecond]: {
    stepId: PropertyStepsEnum.generalSecond,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 2,
  },
  [PropertyStepsEnum.propertyFeatures]: {
    stepId: PropertyStepsEnum.propertyFeatures,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 3,
  },
  [PropertyStepsEnum.propertyAmenities]: {
    stepId: PropertyStepsEnum.propertyAmenities,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 4,
  },
  [PropertyStepsEnum.propertySkillsAmenities]: {
    stepId: PropertyStepsEnum.propertySkillsAmenities,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 5,
  },
  [PropertyStepsEnum.propertyPhoto]: {
    stepId: PropertyStepsEnum.propertyPhoto,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 6,
  },
  [PropertyStepsEnum.propertyLandlord]: {
    stepId: PropertyStepsEnum.propertyLandlord,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 7,
  },
  [PropertyStepsEnum.propertyResidents]: {
    stepId: PropertyStepsEnum.propertyResidents,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 8,
  },
  [PropertyStepsEnum.propertyShare]: {
    stepId: PropertyStepsEnum.propertyShare,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 9,
  },
  [PropertyStepsEnum.congratulations]: {
    stepId: PropertyStepsEnum.congratulations,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 10,
  },
};
